import React, {  } from "react";

export function Fabcerrar({fabAction, isOpen}) {

    return (
      <div onClick={fabAction} className={"menu_cerrarcompany" + (isOpen ? "move" : "")}>
                <div className="menu_cerrarcompany">
                <button className="btn btn--gradient" id="menu_cerrarcompany">
                    <i className="fas fa-arrow-left"></i> 
                    </button>
                </div>
      </div>
    )
  }
  export default Fabcerrar;  